// extracted by mini-css-extract-plugin
export default {"SectionTitle":"ContactSection_SectionTitle__W7Who","EmailIcon":"ContactSection_EmailIcon__09NMp"};